<template>
  <div class="xl:flex">
    <customer-form
      :form="form"
      :sales-reps="salesReps"
      :type-options="typeOptions"
      :route-options="routeOptions"
      :pricing-options="pricingOptions"
      :payment-terms-options="paymentTermsOptions"
      :payment-method-options="paymentMethodOptions"
      :show-enabled-toggle="true"
    />

    <div class="w-full xl:w-2/5 xl:pl-4">
      <delivery-schedule-form
        ref="deliverySchedule"
        :form="form"
        :delivery-options="deliveryOptions"
      />

      <customer-pricing-form
        class="mt-8"
        :form="form"
        :pricing-products-url="pricingProductsUrl"
      />
    </div>
  </div>
</template>

<script>
import CustomerForm from '@/Pages/Customer/Partials/CustomerForm'
import CustomerPricingForm from '@/Pages/Customer/Partials/CustomerPricingForm'
import DeliveryScheduleForm from '@/Pages/Customer/Partials/DeliveryScheduleForm'

export default {
  props: {
    form: Object,
    salesReps: Array,
    deliveryOptions: Array,
    typeOptions: Array,
    routeOptions: Array,
    pricingOptions: Array,
    paymentTermsOptions: Array,
    paymentMethodOptions: Array,
    pricingProductsUrl: String,
  },

  components: {
    CustomerForm,
    CustomerPricingForm,
    DeliveryScheduleForm,
  },

  methods: {
    ensureAuthCode(onReady) {
      if (this.$refs.deliverySchedule?.ensureAuthCode) {
        this.$refs.deliverySchedule.ensureAuthCode(onReady);
        return;
      }
      onReady();
    },

    promptAuthForRetry() {
      this.$refs.deliverySchedule?.promptAuthForRetry?.();
    },
  },
}
</script>
